/* eslint-disable */
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

import { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import Loader from "react-loader-spinner";
import {
  getEnums,
  getSpecificQuestionnaire,
} from "../../utils/store/actions/survey.action";
import {
  getFund,
  getNetAssetValue,
  getNetAssetPartValue,
  getPart,
  getTranslationByPart,
} from "../../utils/store/actions/funds.actions";
import {
  Paper,
} from "@material-ui/core";
import PartSpecificQuestionnaire from "./PartSpecificQuestionnaire";
import {getAllProperties} from "../../utils/store/actions/users.actions";
import PartBackInput from "./PartBackInput";
import PartForm from "./PartForm";
import PartReports from "./PartReports";
import PartDocuments from "./PartDocuments";
import {getPartEnvelopes} from "../../utils/store/actions/document.actions";
import ModalManageDocument from "../../components/Modal/Modal.ManageDocument";
import ModalAddDocumentInDirectory from "../../components/Modal/Modal.AddDocumentInDirectory";
import ModalManageDocumentPart from "../../components/Modal/Modal.ManageDocumentPart";
import PartTranslation from "./PartTranslation";
import React from "react";


class Part extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const partId = urlParams.get("partId");
    const fundPersonId = urlParams.get("id");
    await this.props.getAllProperties();
    await this.props.getFund();
    await this.props.getTranslationByPart(partId);
    await this.props.getFund();
    await this.props.getPart(fundPersonId, partId);
    await this.props.getEnums();
    await this.props.getNetAssetPartValue(fundPersonId, partId);
    this.props.Users &&
    this.props.Users.get_properties &&
    this.props.Users?.get_properties?.find(
      (property: { key: string; value: boolean }) =>
        property.key === "IS_V4_AVAILABLE"
    ).value === "true" &&  !!this.props.Funds.part.partIsin &&
      this.props.getSpecificQuestionnaire(this.props.Funds.part.fundId, this.props.Funds.part.partIsin);
    await this.props.getPartEnvelopes(fundPersonId, partId);
  }

  render() {
    const { Funds, Surveys } = this.props;

    return Funds.part &&
      Object.keys(Funds.part).length !== 0 &&
      Surveys.enums ? (
      <div style={{display: "flex", justifyContent: "space-between"}}>
        <ModalAddDocumentInDirectory/>
        <ModalManageDocumentPart/>
        {/* CONTENT */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          {/* BACK INPUT */}
          <PartBackInput/>
          {/* PART INFORMATION */}
          <PartForm/>
          {/* PART DOCUMENT  */}
          <PartDocuments/>
          {/* PART DOCUMENT  */}
          <PartTranslation/>
          {/* SPECIFIC QUESTIONNAIRE  */}
          <PartSpecificQuestionnaire/>
          {/* REPORTS */}
          <PartReports/>
        </div>
      </div>
    ) : (
      <Paper>
        <Loader
          type="ThreeDots"
          color="#4B0084"
          height={100}
          width={100}
          timeout={3000} //3 secs
        />
      </Paper>
    );
  }
}
const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getFund,
  getTranslationByPart,
  getEnums,
  getNetAssetValue,
  getNetAssetPartValue,
  getSpecificQuestionnaire,
  getAllProperties,
  getPart,
  getPartEnvelopes,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Part));
